









































































import { Vue, Component, Model, Prop, Watch } from "vue-property-decorator";
import DefinitionsAPI from "@/services/definitions";
import Definition, { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";
import { cloneDeep, isArray } from "lodash";
import BaseLoading from "@/components/BaseLoading.vue";

@Component({
  components: { BaseLoading },
})
export default class DefinitionsSelector extends Vue {
  @Model("change") value?: string[];
  @Prop({ default: "components.definitions_selector.title" }) title!: string;
  @Prop({ default: () => [] }) rules!: boolean[];
  @Prop({ default: false }) select!: boolean;
  @Prop({ default: false }) dense!: boolean;
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: null }) filter?: string[];

  items: DefinitionList[] = [];
  loading = true;
  modelSelectMode: { [key: string]: string[] } = {};

  created(): void {
    this.getDefinitions();
  }

  async getDefinitions(): Promise<void> {
    try {
      this.loading = true;
      const r = await DefinitionsAPI.list(1, 100);
      this.items = r.data;

      this.items.forEach((item: DefinitionList) => {
        this.modelSelectMode[item.value] = [];

        this.value && this.value.length > 0
          ? this.groupInitialValues(item.value)
          : null;
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  get selection(): Array<Definition | DefinitionValue> {
    const nodes: Array<Definition | DefinitionValue> = [];
    if (this.value) {
      for (const item of this.items) {
        const selected = item.values.filter((i) =>
          this.value?.includes(i.id as string)
        );
        if (selected.length > 0) {
          const node = cloneDeep(item);
          node.values = selected;
          nodes.push(node);
        }
      }
    }
    return nodes;
  }

  filterItems(items: DefinitionValue[]): Array<DefinitionValue> {
    const filteredItems = this.filter
      ? items.filter((item: DefinitionValue) => {
          const filter = this.filter
            ? this.filter.find((filter: string) => filter === item.id)
            : false;

          return filter;
        })
      : items;

    return filteredItems;
  }

  onChange(items: string | string[], key: string): void {
    let values: string[] = [];

    !isArray(items)
      ? (this.modelSelectMode[key] = [items])
      : (this.modelSelectMode[key] = items);

    Object.keys(this.modelSelectMode).forEach((idx: string) => {
      values = [...values, ...this.modelSelectMode[idx]];
    });

    this.$emit("change", values);
  }

  groupInitialValues(value: string): void {
    this.items.forEach((item: DefinitionList) => {
      if (item.value === value) {
        this.value?.forEach((v: string) => {
          const d = item.values.find((d: DefinitionValue) => {
            return d.id === v;
          });
          d !== undefined
            ? this.modelSelectMode[value].push(String(d.id))
            : null;
        });
      }
    });
  }
}
